import React from "react";
import PropTypes from "prop-types";
import { EmailForm, CtaButton } from "../../Elements";

import {
	RequestSyllabusWrapper,
	TextWrapper,
	Heading,
	FormWrapper,
	RequestSyllabusForm,
	FormHeading,
} from "./style";

const RequestSyllabus = (props) => {
	const { heading, cta, requestSyllabusHeading, context } = props;

	const { apiBaseUrl, workshop_id } = context;
	const apiEndPoint = `${apiBaseUrl}/learning-paths/interested/`;
	const successMessage = "Check your mailbox!";

	return (
		<RequestSyllabusWrapper>
			<TextWrapper>
				<Heading>{heading}</Heading>
				<CtaButton cta={cta} className="join-button" />
			</TextWrapper>
			<FormWrapper>
				<RequestSyllabusForm>
					<FormHeading>{requestSyllabusHeading}</FormHeading>
					<EmailForm
						buttonText="Request syllabus"
						formData={{
							workshop_id,
							syllabus: 1,
							js_disabled: "yes",
						}}
						apiEndPoint={apiEndPoint}
						actionOnSuccess="SHOW_SUCCESS_MESSAGE"
						successMessage={successMessage}
						className={"request-syllabus-form"}
					/>
				</RequestSyllabusForm>
			</FormWrapper>
		</RequestSyllabusWrapper>
	);
};

RequestSyllabus.propTypes = {
	heading: PropTypes.string,
	cta: PropTypes.shape({
		link: PropTypes.shape({
			type: PropTypes.oneOf(["hash", "external", "internal"]),
			value: PropTypes.string,
		}),
		color: PropTypes.string,
		type: PropTypes.oneOf(["solid", "outline"]),
		text: PropTypes.string,
	}),
	requestSyllabusHeading: PropTypes.string,
};

RequestSyllabus.defaultProps = {
	heading: "",
	cta: null,
	requestSyllabusHeading: "",
};

export default RequestSyllabus;
